import { createFileRoute } from '@tanstack/react-router';
import { PlatformRolesTable } from '../../pages/platform/roles/PlatformRolesTable';

// Roles a nivel PLATAFORMA (`/platform/roles`). Hereda el guard de scope PLATFORM del layout padre
// (_layout.platform). El gate fino del item de menú + acciones usa los permisos `platform.role.*`.
export const Route = createFileRoute('/_authenticated/_layout/platform/roles')({
    component: () => <PlatformRolesTable />,
});
